// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor-content[data-v-311b799b] {\n  width: 500px;\n}\n.editor-content-inner[data-v-311b799b] {\n  border: 1px solid #ccc;\n  padding: 10px;\n  height: 400px;\n  overflow-y: auto;\n}\n.editor-content[data-v-311b799b]  img {\n  max-width: 100%;\n  vertical-align: top;\n}", ""]);
// Exports
module.exports = exports;
